import React, { useState, useEffect } from 'react';
import { FaChevronDown } from 'react-icons/fa';

const AboutTestimonials = () => {
  const [selectedLanguage, setSelectedLanguage] = useState('AR');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const languages = ['AR', 'FR', 'EN'];

  const testimonialsData = {
    AR: [
      {
        id: 1,
        name: 'قابوش الويزة',
        testimonial: {
          intro: 'بعد إنتهاء السنة على الذكاء الاصطناعي، أصبحت أكثر وعياً بأهمية',
          title: '"Management Techniques in the Era of Digitalization and Artificial Intelligence"',
          content: [
            'لقد تعلمت، إلا أن الأهداف وطرق تحقيقها هي في الواقع أساس الإدارة الناجحة في الوقت الحالي.',
            'لم تكن هذه الدورة مجرد محاضرات عادية، بل كانت رحلة فكرية ثرية، مزجت فيها الأستاذة بين عمق المعرفة وحداثة الطرح، فقررت مفاهيم الإدارة الحديثة والذكاء الاصطناعي، وأصبحت أمامنا آفاقاً جديدة للتفكير والعمل.',
            'ما يميز الأستاذة نور الهدى، إلى جانب كفاءتها العلمية، هو روحها الجميلة وحنكة خبرتها الرائدة، فهي من أولئك الأشخاص الذين يدخلون القلب دون استئذان، بحسن الخلق، وبساطة التعامل، وصدق العطاء.',
            'فشكراً لها، أستاذتنا الفاضلة، كل الشكر والتقدير والعرفان، على ما بذلته من جهد، وما قدمته من معرفة، وما تركته من أثر طيب لن ننسى، دام عطاؤك، ودام حضورك المشرق في دروب العلم والتكوين.'
          ]
        }
      },
      {
        id: 2,
        name: 'م.مهدي المدير العام لمركز IBM',
        testimonial: {
          content: [
            'بسم الله الرحمن الرحيم وبه نستعين، أن الله الأمانات، أن الأمانة الأساسية للمدير هي تطوير الموارد البشرية والاستثمار في جميع الموظفين الاستثمار الحقيقي.',
            'كما أريد أن أشكر الأستاذة نور الهدى، بل الأستاذة الدكتورة نور الهدى على هذا الجهد الكبير، وعلى هذا العطاء المتميز، وعلى هذا التفاني في خدمة العلم والمعرفة.',
            'شكراً لكم جميعاً على هذا التعاون والإحترافية، وأتمنى أن تكون هذه الدورة قد حققت إضافة حقيقية لمسيرتكم المهنية والشخصية.',
            'وأتمنى لكم دوام التوفيق وحسن الختام ودمتم بخير.'
          ]
        }
      },
      {
        id: 3,
        name: 'فوزية',
        testimonial: {
          content: [
            'بداية شكراً جزيلاً للأستاذة الفاضلة على هذا المجهود الجبار وعلى هذا العطاء المتميز في تقديم هذه الدورة التكوينية القيمة التي استفدنا منها كثيراً.',
            'لقد أضاف لي هذه الدورة معلومات قيمة ومفيدة في مجال الإدارة والذكاء الاصطناعي.'
          ]
        }
      }
    ],
    FR: [
      {
        id: 1,
        name: 'Louiza Kabouche',
        testimonial: {
          intro: 'Après avoir terminé l\'année sur l\'intelligence artificielle, je suis devenu plus conscient de l\'importance de',
          title: '"Management Techniques in the Era of Digitalization and Artificial Intelligence"',
          content: [
            'J\'ai appris que les objectifs et les méthodes pour les atteindre sont en fait la base d\'une gestion réussie à l\'heure actuelle.',
            'Ce cours n\'était pas seulement des conférences ordinaires, mais un voyage intellectuel riche, dans lequel le professeur a mélangé la profondeur des connaissances et la modernité de l\'approche.',
            'Ce qui distingue le professeur Nour El Huda, en plus de sa compétence scientifique, c\'est son beau esprit et la sagesse de son expérience pionnière.',
            'Merci à elle, notre professeur distingué, pour tous ses efforts, ses connaissances et l\'impact positif qu\'elle a laissé.'
          ]
        }
      },
      {
        id: 2,
        name: 'M. Mehdi Directeur Général du Centre IBM',
        testimonial: {
          content: [
            'Au nom d\'Allah, le Tout Miséricordieux, le Très Miséricordieux, la responsabilité fondamentale du manager est de développer les ressources humaines.',
            'Je tiens également à remercier le professeur Nour El Huda pour ce grand effort et cette contribution exceptionnelle au service de la science.',
            'Merci à tous pour cette coopération et ce professionnalisme.',
            'Je vous souhaite un succès continu et que vous restiez en bonne santé.'
          ]
        }
      },
      {
        id: 3,
        name: 'Fawzia',
        testimonial: {
          content: [
            'Tout d\'abord, merci beaucoup au professeur distingué pour cet effort énorme et cette contribution exceptionnelle.',
            'Ce cours m\'a apporté des informations précieuses dans le domaine de la gestion et de l\'intelligence artificielle.'
          ]
        }
      }
    ],
    EN: [
      {
        id: 1,
        name: 'Louiza Kachouch',
        testimonial: {
          intro: 'After completing the year on artificial intelligence, I became more aware of the importance of',
          title: '"Management Techniques in the Era of Digitalization and Artificial Intelligence"',
          content: [
            'I learned that goals and methods to achieve them are actually the foundation of successful management at the present time.',
            'This course was not just ordinary lectures, but a rich intellectual journey, in which the professor mixed depth of knowledge with modern approach.',
            'What distinguishes Professor Nour El Huda, in addition to her scientific competence, is her beautiful spirit and the wisdom of her pioneering experience.',
            'Thank you to her, our distinguished professor, for all her efforts, knowledge, and the positive impact she left.'
          ]
        }
      },
      {
        id: 2,
        name: 'Mr. Mehdi General Manager of IBM Center',
        testimonial: {
          content: [
            'In the name of Allah, the Most Gracious, the Most Merciful, the fundamental responsibility of the manager is to develop human resources.',
            'I also want to thank Professor Nour El Huda for this great effort and exceptional contribution to the service of science.',
            'Thank you all for this cooperation and professionalism.',
            'I wish you continued success and good health.'
          ]
        }
      },
      {
        id: 3,
        name: 'Fawzia',
        testimonial: {
          content: [
            'First of all, thank you very much to the distinguished professor for this enormous effort and exceptional contribution.',
            'This course provided me with valuable information in the field of management and artificial intelligence.'
          ]
        }
      }
    ]
  };

  const currentTestimonials = testimonialsData[selectedLanguage];
  const isRTL = selectedLanguage === 'AR';
  
  // Flatten all testimonials for mobile carousel
  const allTestimonials = currentTestimonials;

  // Auto-scroll effect
  useEffect(() => {
    if (!isPaused && allTestimonials.length > 1) {
      const interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % allTestimonials.length);
      }, 5000); // Change slide every 5 seconds

      return () => clearInterval(interval);
    }
  }, [isPaused, allTestimonials.length]);

  const handleLanguageChange = (language) => {
    setSelectedLanguage(language);
    setIsDropdownOpen(false);
    setCurrentSlide(0); // Reset to first slide when language changes
  };

  const LanguageDropdown = ({ language, testimonialId }) => (
    <div className="relative">
      <button
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        className="bg-gray-100 px-3 py-1 rounded-full flex items-center gap-2 hover:bg-gray-200 transition-colors"
      >
        <span className="text-gray-600 text-sm font-medium">{language}</span>
        <FaChevronDown className={`text-gray-600 text-xs transition-transform ${isDropdownOpen ? 'rotate-180' : ''}`} />
      </button>
      
      {isDropdownOpen && (
        <div className="absolute top-full left-0 mt-1 bg-white border border-gray-200 rounded-lg shadow-lg z-10 min-w-[60px]">
          {languages.map((lang) => (
            <button
              key={lang}
              onClick={() => handleLanguageChange(lang)}
              className={`w-full px-3 py-2 text-left text-sm hover:bg-gray-50 first:rounded-t-lg last:rounded-b-lg ${
                lang === selectedLanguage ? 'bg-blue-50 text-blue-600' : 'text-gray-600'
              }`}
            >
              {lang}
            </button>
          ))}
        </div>
      )}
    </div>
  );

  return (
    <section className="py-4 md:py-20 px-4 max-w-7xl mx-auto">
      {/* Header */}
      <div className="mb-16">
        <h2 className="text-2xl lg:text-4xl font-bold text-gray-900 mb-2 md:mb-8">
          Testimonials from the session
        </h2>
      </div>

      {/* Testimonials Layout */}
      {/* Mobile Carousel */}
      <div className="lg:hidden">
        <div className="relative">
          <div 
            className="overflow-hidden px-4"
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
            onTouchStart={() => setIsPaused(true)}
            onTouchEnd={() => setIsPaused(false)}
          >
            <div 
              className="flex transition-transform duration-300 ease-in-out py-2 gap-4"
              style={{ 
                transform: `translateX(-${currentSlide * 85}%)`,
              }}
            >
              {allTestimonials.map((testimonial, index) => (
                <div 
                  key={testimonial.id} 
                  className="flex-shrink-0 w-[90%]"
                >
                  <div className="bg-white p-6 rounded-2xl h-full" style={{ boxShadow: '0 0 20px rgba(0, 0, 0, 0.1)' }}>
                    {/* Header with Language Dropdown */}
                    <div className="flex justify-between items-start mb-4">
                      <LanguageDropdown language={selectedLanguage} testimonialId={testimonial.id} />
                    </div>

                    {/* Name */}
                    <div className={`mb-4 ${isRTL ? 'text-right' : 'text-left'}`} dir={isRTL ? 'rtl' : 'ltr'}>
                      <h4 className="font-bold text-gray-900 text-base">{testimonial.name}</h4>
                    </div>

                    {/* Testimonial Text */}
                    <div className="mb-4">
                      <div className={`text-gray-700 text-sm leading-relaxed space-y-3 ${isRTL ? 'text-right' : 'text-left'}`} 
                           dir={isRTL ? 'rtl' : 'ltr'} 
                           style={{ fontFamily: 'Arial, sans-serif' }}>
                        {testimonial.testimonial.intro && (
                          <p>{testimonial.testimonial.intro}</p>
                        )}
                        {testimonial.testimonial.title && (
                          <p className="text-gray-500 italic text-center text-xs" dir="ltr">
                            {testimonial.testimonial.title}
                          </p>
                        )}
                        {testimonial.testimonial.content.map((paragraph, pIndex) => (
                          <p key={pIndex}>{paragraph}</p>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Dot Indicators */}
          <div className="flex justify-center mt-6 gap-2">
            {allTestimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-2 h-2 rounded-full transition-all duration-200 ${
                  index === currentSlide ? 'bg-primary-blue' : 'bg-gray-300'
                }`}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Desktop Layout */}
      <div className="hidden lg:flex flex-col lg:flex-row gap-8">
        {/* Left Side - First Testimonial */}
        <div className="lg:w-1/2">
          <div className="bg-white p-8 rounded-2xl hover:shadow-xl transition-shadow duration-300 h-full" style={{ boxShadow: '0 0 20px rgba(0, 0, 0, 0.1)' }}>
            {/* Header with Language Dropdown */}
            <div className="flex justify-between items-start mb-6">
              <LanguageDropdown language={selectedLanguage} testimonialId={1} />
            </div>

            {/* Name */}
            <div className={`mb-4 ${isRTL ? 'text-right' : 'text-left'}`} dir={isRTL ? 'rtl' : 'ltr'}>
              <h4 className="font-bold text-gray-900 text-lg">{currentTestimonials[0].name}</h4>
            </div>

            {/* Testimonial Text */}
            <div className="mb-6">
              <div className={`text-gray-700 leading-relaxed space-y-4 ${isRTL ? 'text-right' : 'text-left'}`} 
                   dir={isRTL ? 'rtl' : 'ltr'} 
                   style={{ fontFamily: 'Arial, sans-serif' }}>
                {currentTestimonials[0].testimonial.intro && (
                  <p>
                    {currentTestimonials[0].testimonial.intro}
                  </p>
                )}
                {currentTestimonials[0].testimonial.title && (
                  <p className="text-gray-500 italic text-center" dir="ltr">
                    {currentTestimonials[0].testimonial.title}
                  </p>
                )}
                {currentTestimonials[0].testimonial.content.map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Right Side - Second and Third Testimonials */}
        <div className="lg:w-1/2 flex flex-col gap-8">
          {currentTestimonials.slice(1).map((testimonial, index) => (
            <div key={testimonial.id} className="bg-white p-8 rounded-2xl hover:shadow-xl transition-shadow duration-300" style={{ boxShadow: '0 0 20px rgba(0, 0, 0, 0.1)' }}>
              {/* Header with Language Dropdown */}
              <div className="flex justify-between items-start mb-6">
                <LanguageDropdown language={selectedLanguage} testimonialId={testimonial.id} />
              </div>

              {/* Name */}
              <div className={`mb-4 ${isRTL ? 'text-right' : 'text-left'}`} dir={isRTL ? 'rtl' : 'ltr'}>
                <h4 className="font-bold text-gray-900 text-lg">{testimonial.name}</h4>
              </div>

              {/* Testimonial Text */}
              <div className="mb-6">
                <div className={`text-gray-700 leading-relaxed space-y-4 ${isRTL ? 'text-right' : 'text-left'}`} 
                     dir={isRTL ? 'rtl' : 'ltr'} 
                     style={{ fontFamily: 'Arial, sans-serif' }}>
                  {testimonial.testimonial.content.map((paragraph, pIndex) => (
                    <p key={pIndex}>{paragraph}</p>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutTestimonials;